import { useMemo } from 'react';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { View } from 'foundations-components/components/View';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { isDate } from 'customer-data-objects/property/PropertyIdentifier';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MultiLineString = styled.span.withConfig({
  displayName: "HeaderComponent__MultiLineString",
  componentId: "sc-1laxq30-0"
})(["white-space:normal;text-align:left;"]);
export function HeaderContent({
  column
}) {
  const label = column.propertyDescriptor ? column.propertyDescriptor.label : column.id;
  const dateTimeCellContent = column.propertyDescriptor && isDate(column.propertyDescriptor) ? /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "datetime-header",
    message: "frameworkListingLib.cells.datetime.header",
    options: {
      label,
      timezone: I18n.moment.userTz().format('z')
    }
  }) : null;
  if (column.multiline) {
    return /*#__PURE__*/_jsx(BreakString, {
      children: /*#__PURE__*/_jsx(MultiLineString, {
        "data-test-id": "multiline-header-component",
        children: dateTimeCellContent || label
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dateTimeCellContent || label
  });
}
export default function HeaderComponent({
  children,
  column
}) {
  const helpText = useMemo(() => column.propertyDescriptor && column.propertyDescriptor.description, [column.propertyDescriptor]);
  if (column.HeaderTooltip) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      useFlex: true,
      fixedChildren: column.HeaderTooltip,
      "data-test-id": "truncated-header-component",
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "100",
        "aria-hidden": true,
        "data-test-id": "header-component-with-custom-tooltip",
        children: children
      })
    });
  }

  // Putting the UIHelpIcon in fixedChildren means that it won't get truncated
  // or appear in the tooltip that appears over the truncated text.
  if (helpText) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      useFlex: true,
      fixedChildren: /*#__PURE__*/_jsx(UIHelpIcon, {
        className: "m-left-1",
        title: helpText,
        tooltipPlacement: "top"
      }),
      "data-test-id": "truncated-header-component",
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        "aria-hidden": true,
        "data-test-id": "header-component-with-help-text",
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    "data-test-id": "truncated-header-component",
    children: /*#__PURE__*/_jsx(View, {
      as: "span",
      "aria-hidden": true,
      "data-test-id": "header-component",
      children: children
    })
  });
}